import { updateSearch } from 'bernie-core';

import { copyToClipboard } from 'utils/clipboard-utils';
import { handleSignInSignUpClick } from 'utils/auth-utils';

import { History, Location } from 'history';

export enum KNOWN_ACTIONS {
  COPY = 'copy',
  AUTHWINDOW = 'authwindow',
  TERMS_AND_CONDITIONS = 'terms_and_conditions',
  FREE_LX = 'free_lx',
  EXTERNAL_LINK = 'external_link',
  OPEN = 'open',
}

interface ResolveActionParameter {
  actionDetails?: ResolveActionBehaviorStructure;
  href?: string;
}

interface ResolveActionBehaviorStructure {
  name: string;
  details?: string;
  searchOption?: {
    name?: string;
    value?: string;
  };
}

export class MessagingCardActions {
  public static resolveAction(
    history: History,
    location: Location,
    param: ResolveActionParameter,
    analytics: any = null,
    showNotification: () => void = null,
    externalUrl: string = null
  ): (e: Event) => void {
    const { actionDetails, href } = param;
    const stringActionName = actionDetails && actionDetails.name && actionDetails.name.trim().toUpperCase();
    const enumAction = KNOWN_ACTIONS[stringActionName];

    if (enumAction) {
      return (e: Event) => {
        e.preventDefault();
        e.stopPropagation();

        switch (enumAction) {
          case KNOWN_ACTIONS.TERMS_AND_CONDITIONS:
            updateSearch({ history, location, newParams: { pwaDialog: 'couponTerms' } });
            break;
          case KNOWN_ACTIONS.COPY:
            copyToClipboard(actionDetails.details, showNotification);
            break;
          case KNOWN_ACTIONS.AUTHWINDOW:
            handleSignInSignUpClick(e, analytics, history, location, actionDetails.details, actionDetails.searchOption);
            break;
          case KNOWN_ACTIONS.FREE_LX:
            updateSearch({ history, location, newParams: { pwaDialog: 'freeLxTerms' } });
            break;
          case KNOWN_ACTIONS.EXTERNAL_LINK:
            window.open(externalUrl);
            break;
          case KNOWN_ACTIONS.OPEN:
            window.open(href);
            break;
          default:
            return;
        }
      };
    }

    return;
  }
}
